import Link from "next/link";
import { Stack, List } from "@chakra-ui/react";
import { Heading } from "@/elements";
import { POLICIES_CONSTANTS } from "./constants";

const PoliciesComponent = () => {
  return (
    <Stack id="policies" gap={6}>
      {POLICIES_CONSTANTS.map((policy) => (
        <Stack id={policy.ID} gap={2} key={policy.ID}>
          <Heading as="h2" variant={"subTitle2"}>
            {policy.LABEL}
          </Heading>
          <List.Root as="ol" gap={1}>
            {policy.ITEMS.map((item, index) => (
              <List.Item key={index} fontSize={"18px"} color={"#1E87F0"}>
                <Link href={item.path} style={{ textDecoration: "underline" }}>
                  {item.name}
                </Link>
              </List.Item>
            ))}
          </List.Root>
        </Stack>
      ))}
    </Stack>
  );
};

export default PoliciesComponent;
